const JPage     = () => import('../views/data/jpage');
const fdatas    = () => import('../views/data/fdatas');
const fdetail   = () => import('../views/data/fdetail');
const fadd      = () => import('../views/data/fadd');
const wurl      = () => import('../views/data/wurl');
const Compage   = () => import('../views/data/compage');
// const Approve   = () => import('../views/portal/approve');
// const App       = () => import('../views/portal/app');

export default [{
    name: 'portal-datas',
    path: 'datas/:contentId',
    component: (resolve) => require(['../views/data/datas'], resolve),
}/*, {
    name: 'portal-form',
    path: 'formdata',
    component: (resolve) => require(['../views/data/form'], resolve)
}*/, {
    name: 'portal-iframe',
    path: 'iframe/:contentId',
    component: (resolve) => require(['../views/data/iframe'], resolve),
}, {
    name: 'portal-jzlpage',
    path: 'jzlpage/:contentId',
    component: JPage     // (resolve) => require(['../views/data/page'], resolve),
}/*, {
    name: 'portal-jpage',
    path: 'jpage',
    component: JPage    // (resolve) => require(['../views/data/jpage'], resolve),
}*/, {
    name: 'portal-data-detail',
    path: 'data-detail',
    component: (resolve) => require(['../views/data/detail'], resolve),
},
/** 通用路由 **/
/*{
    name: 'app',
    path: 'app',
    component: App      // (resolve) => require(['../views/portal/app'], resolve),
}, {
    name: 'approve',
    path: 'approve',
    component: Approve
}, */{
    name: 'compage',
    path: 'compage',
    component: Compage
}, {
    name: 'page',
    path: 'page',
    component: JPage    // (resolve) => require(['../views/portal/page'], resolve),
}, {
    name: 'jpage',
    path: 'jpage',
    component: JPage   // (resolve) => require(['../views/portal/detail'], resolve)
}, {
    name: 'fdatas',
    path: 'fdatas',
    component: fdatas   // (resolve) => require(['../views/portal/detail'], resolve)
}, {
    name: 'fdetail',
    path: 'fdetail',
    component: fdetail   // (resolve) => require(['../views/portal/detail'], resolve)
}, {
    name: 'fadd',
    path: 'fadd',
    component: fadd   // (resolve) => require(['../views/portal/detail'], resolve)
}, {
    name: 'wurl',
    path: 'wurl',
    component: wurl
}]
